/*
 *==================================================
 * Licensed Materials - ADIACENT
 *
 * user roles (mroService.getRoles) held in redux state
 *
 *==================================================
 */
//Standard libraries
import { createReducer, AnyAction } from "@reduxjs/toolkit";
//Redux
import initStates from "./initStates";
import { UserRolesReducerState } from "./reducerStateInterface";
import {
  USER_ROLES_GET_SUCCESS_ACTION,
  USER_ROLES_RESET_ACTION,
} from "../actions/userRoles";

/**
 * userRolesReducer reducer
 */
const userRolesReducer = createReducer(initStates.userRoles, (builder) => {

  builder.addCase(
    USER_ROLES_GET_SUCCESS_ACTION,
    (state: UserRolesReducerState | any, action: AnyAction) => {
      state.roles = action.payload?.roles ?? [];
      state.initialized = true;
    }
  );

  builder.addCase(
    USER_ROLES_RESET_ACTION,
    (state: UserRolesReducerState | any, action: AnyAction) => {
      state.roles = [];
      state.initialized = false;
    }
  );

});
export default userRolesReducer;
